var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checkbox",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#df995c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M15.09,22.634c-.5-.563-.905-1.113-1.3-1.646a9.383,9.383,0,0,1-.924-1.546c-.161-.33-.233-.664.117-.879,1-.616,1.207-.028,1.752.654.323.4.8,1.071,1.1,1.492.285.4.632-.324.771-.528.493-.728,1.773-2.51,2.3-3.168.5-.625,2.124-2.377,2.426-2.655.257-.237.8-.758,1.166-.471a.963.963,0,0,1,.3,1.248c-.47.649-1.208,1.266-1.719,1.884-1.034,1.251-2.013,2.6-2.952,3.942-.319.456-.768,1.22-1.046,1.715C16.564,23.6,16.106,23.777,15.09,22.634Z",
    transform: "translate(-5.832 -6.616)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.f4b2a5fbad7601dab4cf77e34542f527.svg";
export { ForwardRef as ReactComponent };